/* eslint-disable no-unused-vars */
import React, { useMemo } from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';
import { Transaction, warranties } from 'src/types';
import { ViewWarrantyRow } from './ViewWarranty';
import { TextBoldWarranty, TextRegularWarranty } from './TextWarranty';
import { cloneDeep } from 'lodash';
import { ProductTypeEnum } from 'src/enums';
import { RenderCurrency } from './RenderCurrency';

interface Props {
  items?: Transaction[];
  isBlankPage?: boolean;
  isLastPage?: boolean;
  kachiPoints?: number; // this is negative number
  voucherDiscount?: number;
  voucher_code?: string;
}

const textLineHeight = 0.8;

const styles = StyleSheet.create({
  main: {
    marginTop: 45,
    // borderRightWidth: 0.5
  },
  // header: {
  //   height: 20
  // },
  // headerColumn: {
  //   alignItems: 'center',
  //   justifyContent: 'center',
  //   borderTopWidth: 0.5,
  //   borderLeftWidth: 0.5,
  //   borderBottomWidth: 0.5
  // },
  // itemColumnContainer: {
  //   minHeight: 15
  // },
  itemColumn: {
    // paddingVertical: 2,
    // borderLeftWidth: 0.5,
    // borderBottomWidth: 0.5,
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  descriptionOrSnText: {
    // paddingHorizontal: 5
    lineHeight: textLineHeight
  }
});

const flexSizeOfColumns = {
  qty: 0.3,
  description: 4,
  unitPrice: 1,
  amount: 1
};

const headerColumns = [
  {
    flex: flexSizeOfColumns.description,
    title: 'Product Name / Serial No.'
  },
  { flex: flexSizeOfColumns.qty, title: 'Qty' },
  {
    flex: flexSizeOfColumns.unitPrice,
    title: 'Unit Price'
  },
  { flex: flexSizeOfColumns.amount, title: 'Amount' }
];

const kachiPointsTitle = 'KACHI POINTS USED:';
const voucherDiscountTitle = 'VOUCHER CODE:';

type ItemPerLineData = {
  product_id?: number;
  quantity?: number;
  title?: string;
  retail_price?: number;
  amount?: number;
  hidden?: boolean;
  // spend_kachi_points?: number;
  
};

export const RenderItemsTable = ({
  items,
  isBlankPage,
  kachiPoints,
  isLastPage,
  voucherDiscount,
  voucher_code
}: Props) => {
  const numberOfLinesOfItems = useMemo(() => {
    let actualRowsTaken = 0;
    const clonedTransactionItems = cloneDeep(items || []);
    clonedTransactionItems?.forEach((item) => {
      const itemName = item.product_name;
      if (itemName) {
        actualRowsTaken++;
      }
      if (
        item?.product_type !== ProductTypeEnum.Consumable &&
        item?.serial_nos &&
        item?.serial_nos?.length > 0
      ) {
        item?.serial_nos?.forEach((x) => {
          if (x) {
            actualRowsTaken++;
          }
        });
      }
      item.warranty_duration !== 0 && actualRowsTaken++;
      item.category_id === 39 &&
        item.category_name === 'Laptop' &&
        actualRowsTaken++;
    });

    if (isLastPage && (kachiPoints || voucherDiscount)) {
      if (kachiPoints !== 0) actualRowsTaken++;
      if (voucherDiscount !== 0) actualRowsTaken++;
    }

    actualRowsTaken++;
    return actualRowsTaken;
  }, [isLastPage, items, kachiPoints, voucherDiscount]);

  const itemsWithNothingToFollow = useMemo(() => {
    const limitOfLinePerPage = 19;
    if (numberOfLinesOfItems < limitOfLinePerPage) {
      // const numOfDummyLinesToAdd = limitOfLinePerPage - numberOfLinesOfItems;
      const numOfDummyLinesToAdd = 0;
      const clonedTransactionItems = cloneDeep(items);

      if (isLastPage) {
        const hasKachiPoints = kachiPoints !== undefined && kachiPoints !== 0;
        const hasVoucherDiscount =
          voucherDiscount !== undefined && voucherDiscount !== 0;

        if (hasKachiPoints) {
          clonedTransactionItems?.push({
            product_name: kachiPointsTitle,
            retail_price: undefined,
            amount: Math.abs(kachiPoints)
          });
        }

        if (hasVoucherDiscount) {
          clonedTransactionItems?.push({
            product_name: `${voucherDiscountTitle} ${voucher_code}`,
            retail_price: undefined,
            amount: Math.abs(voucherDiscount)
          });
        }
      }

      // clonedTransactionItems?.push({
      //   product_name:
      //     isBlankPage || !isLastPage ? ' ' : '-------- Nothing Follows --------'
      // });

      // const dummyLines = Array.from({ length: numOfDummyLinesToAdd }, () => ({
      //   product_name: '   '
      // }));
      // clonedTransactionItems?.push(...dummyLines);

      return clonedTransactionItems;
    }

    return items;
  }, [
    numberOfLinesOfItems,
    items,
    kachiPoints,
    voucher_code,
    voucherDiscount,
    isBlankPage,
    isLastPage
  ]);

  const itemsArrayOnPerLine = useMemo(() => {
    let newItemsArr: ItemPerLineData[] = [];
    const clonedItemsWithNothingFollows = cloneDeep(itemsWithNothingToFollow);

    clonedItemsWithNothingFollows?.forEach((transactionItem) => {
      // if (x?.product_name) {
        newItemsArr?.push({
          product_id: transactionItem?.product_id,
          quantity: transactionItem?.ll_quantity,
          title: transactionItem?.ll_description,
          // title: 'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
          retail_price: transactionItem?.ll_unit_per_cost,
          amount: transactionItem?.ll_amount,
          // spend_kachi_points: x?.spend_kachi_points
        });
      // }
      // if (x?.serial_nos && x?.serial_nos?.length > 0) {
      //   x?.serial_nos?.forEach((sn) => newItemsArr?.push({ title: sn }));
      // }
      // if (x?.warranty_duration) {
      //   const warranyDuration = warranties?.find((warranty) => {
      //     return warranty?.value === x?.warranty_duration;
      //   });
      //   newItemsArr?.push({
      //     title: `WARRANTY: ${warranyDuration?.name}${
      //       x.category_id === 39 && x.category_name === 'Laptop'
      //         ? '\nBATTERY WARRANTY: 1 YEAR - (365 DAYS)'
      //         : ''
      //     }`
      //   });
      // }
    });


    // for (let i = 0; i < 20; i++) {
    //   newItemsArr.push({
    //     product_id: 12,
    //     quantity: 999,
    //     // title: transactionItem?.ll_description,
    //     title: 'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    //     retail_price: 999999,
    //     amount: 999999,
    //     // spend_kachi_points: x?.spend_kachi_points
    //   });
    // }

    return newItemsArr;
  }, [itemsWithNothingToFollow]);

  const displayQuantity = (item: ItemPerLineData) => {
    if (item.product_id) {
      return item.quantity || '1';
    }

    return item.quantity || '';
  };

  const ItemRow = ({ item }: { item: ItemPerLineData }) => {
    return (
      <ViewWarrantyRow
        style={{
          // height: item?.title && item?.title?.length >= 40 ? 'auto' : 17
        }}
      >
        <View
          style={[
            styles.itemColumn,
            { flex: flexSizeOfColumns.description, alignItems: 'flex-start' }
          ]}
        >
          <TextRegularWarranty style={styles.descriptionOrSnText}>
            {/* {item?.title?.toUpperCase()} */}
            {item?.title?.toUpperCase()}
          </TextRegularWarranty>

        </View>

        <View style={[styles.itemColumn, { flex: flexSizeOfColumns.qty }]}>
          <TextRegularWarranty style={{ lineHeight: textLineHeight }}>{displayQuantity(item)}</TextRegularWarranty>
        </View>

        <View
          style={[styles.itemColumn, { flex: flexSizeOfColumns.unitPrice }]}
        >
          <TextRegularWarranty style={{ lineHeight: textLineHeight }}>
            {item?.retail_price === undefined ? null : (
              <>
                {item?.title?.startsWith(kachiPointsTitle) ||
                item?.title?.startsWith(voucherDiscountTitle) ? (
                  <>
                    {'-'}
                    <RenderCurrency amount={item?.retail_price || 0} />
                  </>
                ) : (
                  <RenderCurrency amount={item?.retail_price || 0} />
                )}
              </>
            )}
          </TextRegularWarranty>
        </View>
        <View style={[styles.itemColumn, { flex: flexSizeOfColumns.amount }]}>
          <TextRegularWarranty style={{ lineHeight: textLineHeight }}>
            {item?.amount === undefined ? null : (
              <>
                {item?.title?.startsWith(kachiPointsTitle) ||
                item?.title?.startsWith(voucherDiscountTitle) ? (
                  <>
                    {'-'}
                    <RenderCurrency amount={item?.amount || 0} />
                  </>
                ) : (
                  <RenderCurrency amount={item?.amount || 0} />
                )}
              </>
            )}
          </TextRegularWarranty>
        </View>
      </ViewWarrantyRow>
    );
  };

  return (
    <View style={styles.main}>
      {/* <TextBoldWarranty>{JSON.stringify(items?.[0])}</TextBoldWarranty> */}
      {itemsArrayOnPerLine?.map((item, i) => (
        <ItemRow key={i} item={item} />
      ))}

    </View>
  );
};
